import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";

// import component
import App from "./App";

// import style
import "./style/index.scss";

// get store
import store from "./store";
// Initialize the single app-wide feedback system before feature modules render.
import "./components/Notifications/openNotification";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);
